/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponse } from '../models';
// @ts-ignore
import type { CancelSubscriptionRequest } from '../models';
// @ts-ignore
import type { SubscriptionListResponse } from '../models';
// @ts-ignore
import type { SubscriptionResponse } from '../models';
/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
export const SubscriptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 구독 활성화
         * @param {string} subscriptionId 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSubscription: async (subscriptionId: string, body?: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('activateSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/api/v1/subscriptions/{subscriptionId}/activate`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 구독 취소
         * @param {string} subscriptionId 
         * @param {CancelSubscriptionRequest} [cancelSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (subscriptionId: string, cancelSubscriptionRequest?: CancelSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('cancelSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/api/v1/subscriptions/{subscriptionId}/cancel`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 구독 상세 조회
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionById: async (subscriptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('getSubscriptionById', 'subscriptionId', subscriptionId)
            const localVarPath = `/api/v1/subscriptions/{subscriptionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 구독 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
export const SubscriptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 구독 활성화
         * @param {string} subscriptionId 
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateSubscription(subscriptionId: string, body?: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateSubscription(subscriptionId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.activateSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 구독 취소
         * @param {string} subscriptionId 
         * @param {CancelSubscriptionRequest} [cancelSubscriptionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(subscriptionId: string, cancelSubscriptionRequest?: CancelSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(subscriptionId, cancelSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.cancelSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 구독 상세 조회
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptionById(subscriptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptionById(subscriptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.getSubscriptionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 구독 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionsApi.getSubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionsApi - factory interface
 * @export
 */
export const SubscriptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionsApiFp(configuration)
    return {
        /**
         * 
         * @summary 구독 활성화
         * @param {SubscriptionsApiActivateSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSubscription(requestParameters: SubscriptionsApiActivateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse> {
            return localVarFp.activateSubscription(requestParameters.subscriptionId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 구독 취소
         * @param {SubscriptionsApiCancelSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(requestParameters: SubscriptionsApiCancelSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse> {
            return localVarFp.cancelSubscription(requestParameters.subscriptionId, requestParameters.cancelSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 구독 상세 조회
         * @param {SubscriptionsApiGetSubscriptionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptionById(requestParameters: SubscriptionsApiGetSubscriptionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.getSubscriptionById(requestParameters.subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 구독 목록 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionListResponse> {
            return localVarFp.getSubscriptions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionsApi - interface
 * @export
 * @interface SubscriptionsApi
 */
export interface SubscriptionsApiInterface {
    /**
     * 
     * @summary 구독 활성화
     * @param {SubscriptionsApiActivateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    activateSubscription(requestParameters: SubscriptionsApiActivateSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse>;

    /**
     * 
     * @summary 구독 취소
     * @param {SubscriptionsApiCancelSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    cancelSubscription(requestParameters: SubscriptionsApiCancelSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponse>;

    /**
     * 
     * @summary 구독 상세 조회
     * @param {SubscriptionsApiGetSubscriptionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    getSubscriptionById(requestParameters: SubscriptionsApiGetSubscriptionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse>;

    /**
     * 
     * @summary 구독 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApiInterface
     */
    getSubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionListResponse>;

}

/**
 * Request parameters for activateSubscription operation in SubscriptionsApi.
 * @export
 * @interface SubscriptionsApiActivateSubscriptionRequest
 */
export interface SubscriptionsApiActivateSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionsApiActivateSubscription
     */
    readonly subscriptionId: string

    /**
     * 
     * @type {object}
     * @memberof SubscriptionsApiActivateSubscription
     */
    readonly body?: object
}

/**
 * Request parameters for cancelSubscription operation in SubscriptionsApi.
 * @export
 * @interface SubscriptionsApiCancelSubscriptionRequest
 */
export interface SubscriptionsApiCancelSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionsApiCancelSubscription
     */
    readonly subscriptionId: string

    /**
     * 
     * @type {CancelSubscriptionRequest}
     * @memberof SubscriptionsApiCancelSubscription
     */
    readonly cancelSubscriptionRequest?: CancelSubscriptionRequest
}

/**
 * Request parameters for getSubscriptionById operation in SubscriptionsApi.
 * @export
 * @interface SubscriptionsApiGetSubscriptionByIdRequest
 */
export interface SubscriptionsApiGetSubscriptionByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionsApiGetSubscriptionById
     */
    readonly subscriptionId: string
}

/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
export class SubscriptionsApi extends BaseAPI implements SubscriptionsApiInterface {
    /**
     * 
     * @summary 구독 활성화
     * @param {SubscriptionsApiActivateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public activateSubscription(requestParameters: SubscriptionsApiActivateSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).activateSubscription(requestParameters.subscriptionId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 구독 취소
     * @param {SubscriptionsApiCancelSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public cancelSubscription(requestParameters: SubscriptionsApiCancelSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).cancelSubscription(requestParameters.subscriptionId, requestParameters.cancelSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 구독 상세 조회
     * @param {SubscriptionsApiGetSubscriptionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public getSubscriptionById(requestParameters: SubscriptionsApiGetSubscriptionByIdRequest, options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).getSubscriptionById(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 구독 목록 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    public getSubscriptions(options?: RawAxiosRequestConfig) {
        return SubscriptionsApiFp(this.configuration).getSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }
}

